import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Search, FileText, Truck, ShieldCheck } from "lucide-react";
import SEO from "@/components/app/SEO";

const steps = [
  { i: 1, icon: Search, title: "Trouvez votre organisme", d: "Recherchez dans notre annuaire de milliers d'entreprises françaises. Nous vous indiquons si une résiliation gratuite est possible directement chez l'organisme." },
  { i: 2, icon: FileText, title: "Répondez au questionnaire", d: "Motif, dates, références de contrat. Notre assistant sélectionne dynamiquement les questions pertinentes selon votre situation." },
  { i: 3, icon: FileText, title: "Générez votre courrier", d: "Un courrier de résiliation personnalisé est automatiquement produit, avec l'objet, les références et les motifs adéquats." },
  { i: 4, icon: Truck, title: "Envoi en recommandé", d: "Nous imprimons, mettons sous pli, et envoyons votre courrier en LRAR. Vous obtenez un numéro de suivi." },
  { i: 5, icon: ShieldCheck, title: "Suivi & preuves", d: "Timeline détaillée, accusé de réception, preuve de dépôt : tout est archivé dans votre coffre-fort numérique." },
];

export default function HowItWorksPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16">
      <SEO
        title="Comment ça marche"
        description="Le parcours Résiliation Express : recherche de l'organisme, questionnaire guidé, génération du courrier, envoi en recommandé, preuves archivées."
        canonical="/comment-ca-marche"
      />
      <div className="mb-12">
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold mb-3">Comment ça marche</p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">De la recherche à la preuve, en 5 étapes.</h1>
      </div>

      <div className="space-y-6">
        {steps.map((s) => (
          <div key={s.i} className="card-elevated p-6 grid grid-cols-1 md:grid-cols-[80px_1fr] gap-6" data-testid={`hiw-step-${s.i}`}>
            <div className="flex md:flex-col items-center md:items-start gap-3">
              <div className="h-12 w-12 rounded-lg bg-gradient-brand flex items-center justify-center">
                <s.icon className="h-6 w-6 text-white" />
              </div>
              <div className="font-mono text-xs text-muted-foreground">ÉTAPE {String(s.i).padStart(2, "0")}</div>
            </div>
            <div>
              <h2 className="text-xl font-semibold mb-2">{s.title}</h2>
              <p className="text-muted-foreground leading-relaxed">{s.d}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 flex justify-center">
        <Button asChild size="lg" className="bg-gradient-brand text-white border-0 hover:opacity-90" data-testid="hiw-start-btn">
          <Link to="/resilier">Commencer maintenant</Link>
        </Button>
      </div>
    </div>
  );
}
